import { Container, Stack, Typography, Button } from '@mui/material';
import { useAuth0Generic } from '@hooks/auth';

export const NotAuthorized = () => {
  const { logout } = useAuth0Generic();

  return (
    <Container
      component={'main'}
      maxWidth="lg"
      sx={{
        paddingY: '2rem',
        paddingX: '1rem',
        height: '75vh',
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        height="inherit"
        gap={2}
      >
        <Typography variant="h2">403</Typography>
        <Typography variant="h3">Acceso denegado</Typography>
        <div className="text-center">
          <Typography fontSize={22}>
            No tienes los permisos necesarios para acceder a esta aplicación.
          </Typography>
          <Typography fontSize={22}>
            Si crees que esto es un error, por favor manda un correo a{' '}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:ti@99minutos.com"
              style={{
                fontWeight: 600,
                color: '#85c440',
              }}
            >
              ti@99minutos.com
            </a>{' '}
            para obtener ayuda.
          </Typography>
        </div>
        <Button
          variant="contained"
          color="primary"
          sx={{ marginTop: '1rem' }}
          onClick={logout}
        >
          Iniciar sesión
        </Button>
      </Stack>
    </Container>
  );
};